import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "@/web/components/ui/button";

export default function AccountIndex() {
  return (
    <>
      <Helmet><title>My Account | Cool Wave</title></Helmet>
      <section className="container py-14">
        <h1 className="mb-3 text-3xl font-bold">My account</h1>
        <p className="mb-6 text-body">Sign in to view your orders, addresses and saved details.</p>
        <div className="flex gap-3">
          <Button asChild><Link to="/account/login">Sign in</Link></Button>
          <Button asChild variant="outline"><Link to="/account/register">Create account</Link></Button>
        </div>
      </section>
    </>
  );
}
